$(document).ready(function(){

    function tabSlider(){
          $('.tabs .product-grid.slick-initialized ').slick('unslick');
          $('.tabs .product-grid ').slick({
            dots: true,
            arrows: true, 
            infinite: true,
            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 1,
            centerMode: false,
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1,
                  infinite: true
                }
              },
              {
                breakpoint: 767,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1
                }
              },
              {
                breakpoint: 480,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              }
            
            ]
          });
    }
        
    $( "#tabs" ).tabs({
      create: function( event, ui ) {
      
       tabSlider()
            
      },
      activate: function( event, ui ) {
   
       tabSlider()
          
      }
    });
  
    $('body').css('cursor', 'url("https://cdn.shopify.com/s/files/1/0440/6879/8622/files/Cursor-Default-new.svg?v=1731389224") 14 14, auto');
    
    // Change cursor on hover for links and buttons, overriding pointer
    $("a, .button, button:not(:disabled), .slick-arrow, .link, .product-form__input--pill input[type='radio'] + label,.product__media-toggle::after,.field__button,.accordion__header-box,.navtab,.vid-content-wrapper,.list-social__item,.accordion__title-box,.accordion-box strong").hover(
        function() {
            $(this).css('cursor', 'url("https://cdn.shopify.com/s/files/1/0440/6879/8622/files/Cursor-Hover-new.svg?v=1731389224") 14 14, auto');
        },
        function() {
            $(this).css('cursor', 'url("https://cdn.shopify.com/s/files/1/0440/6879/8622/files/Cursor-Default-new.svg?v=1731389224") 14 14, auto');
        }
    );

    $( ".product__info-container .price" ).append( $( "[id^=shopify-block-judge_me_reviews_preview_badge_]" ) );
    $( ".product__info-container .price" ).append( $( "[id^=shopify-block-AMXUrdWFpUzVha1hZd__okendo_star_rating]" ) );
    $( ".product__info-container .price" ).append( $( "[id^=shopify-block-AUHlWdzJDZGJsNVF3T__okendo_star_rating]" ) ); 
    $(document).ready(function() {
      if ($(".varaint-quantity--wrapper").length === 0) {
        $("<div class='varaint-quantity--wrapper'></div>").insertAfter(".product__description");
      }
    
      if ($("[id^=variant-selects-template--]").length) {
        $(".varaint-quantity--wrapper").append($("[id^=variant-selects-template--]"));
      }
    });
   




     function initSlick() {
      if ($(window).width() < 749) {
        if (!$('.we-believe-content').hasClass('slick-initialized')) {
          $('.we-believe-content').slick({
            dots: true,
            prevArrow:"<button type='button' class='slick-prev pull-left'> <svg width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'> <rect x='0.5' y='0.941406' width='47' height='47' rx='4.5' stroke='#C6AD93'/> <path d='M32 23.4414H19.83L25.42 17.8514L24 16.4414L16 24.4414L24 32.4414L25.41 31.0314L19.83 25.4414H32V23.4414Z' fill='#82542D'/></svg> </button>",
            nextArrow:"<button type='button' class='slick-next pull-right'> <svg width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'> <rect x='0.5' y='0.941406' width='47' height='47' rx='4.5' stroke='#C6AD93'/> <path d='M24 16.4414L22.59 17.8514L28.17 23.4414H16V25.4414H28.17L22.59 31.0314L24 32.4414L32 24.4414L24 16.4414Z' fill='#82542D'/> </svg></button>",
            arrow:true,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
          });
        }
      } else {
        if ($('.we-believe-content').hasClass('slick-initialized')) {
          $('.we-believe-content').slick('unslick');
        }
      }
    }
  
    initSlick();

    
    function initializeSlick() {
      if ($(window).width() < 749) {
        if (!$('.image-wrapper').hasClass('slick-initialized')) {
          $('.image-wrapper').slick({
            dots: true,
            prevArrow:"<button type='button' class='slick-prev pull-left'> <svg width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'> <rect x='0.5' y='0.941406' width='47' height='47' rx='4.5' stroke='#C6AD93'/> <path d='M32 23.4414H19.83L25.42 17.8514L24 16.4414L16 24.4414L24 32.4414L25.41 31.0314L19.83 25.4414H32V23.4414Z' fill='#82542D'/></svg> </button>",
            nextArrow:"<button type='button' class='slick-next pull-right'> <svg width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'> <rect x='0.5' y='0.941406' width='47' height='47' rx='4.5' stroke='#C6AD93'/> <path d='M24 16.4414L22.59 17.8514L28.17 23.4414H16V25.4414H28.17L22.59 31.0314L24 32.4414L32 24.4414L24 16.4414Z' fill='#82542D'/> </svg></button>",
            arrow:true,
            infinite: true,
            speed: 300, 
            slidesToShow: 1,
            slidesToScroll: 1,
            
          });
        }
      } else {
        if ($('.image-wrapper').hasClass('slick-initialized')) {
          $('.image-wrapper').slick('unslick');
        }
      }
    }
    initializeSlick();




  // slick for power of cacao section
    function slickFeatured() {
      if ($(window).width() < 749) {
        if (!$('.featured-images-inner').hasClass('slick-initialized')) {
          $('.featured-images-inner').slick({
            dots: false,
           arrow:false,
            infinite: true,
            speed: 300,
            slidesToShow: 3,
            slidesToScroll: 1
          });
        }
      } else {
        if ($('.featured-images-inner').hasClass('slick-initialized')) {
          $('.featured-images-inner').slick('unslick');
        }
      }
    }
    slickFeatured();


  // slick for product tabs
    function slickAccordion() {
      if ($(window).width() < 991) {
        if (!$('.mobile-slider').hasClass('slick-initialized')) {
          // Initialize Slick Slider
          $('.mobile-slider').slick({
            dots: true,
            arrows: false,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '0px',
            swipe: true,
            draggable: true
          });
    
          // Add mouse wheel scroll functionality
          $('.mobile-slider').on('wheel', function (e) {
            e.preventDefault();
    
            if (e.originalEvent.deltaY < 0) {
              // Scroll up: Slide to previous
              $(this).slick('slickPrev');
            } else {
              // Scroll down: Slide to next
              $(this).slick('slickNext');
            }
          });
        }
      } else {
        // Destroy Slick Slider if screen is wider than 991px
        if ($('.mobile-slider').hasClass('slick-initialized')) {
          $('.mobile-slider').slick('unslick');
          $('.mobile-slider').off('wheel'); // Remove wheel event listener
        }
      }
    }

    slickAccordion();
    




    function initSlickDifference() {
      if ($(window).width() < 749) {
        if (!$('.our-difference-content').hasClass('slick-initialized')) {
          $('.our-difference-content').slick({
            dots: true,
            prevArrow:"<button type='button' class='slick-prev pull-left'> <svg width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'> <rect x='0.5' y='0.941406' width='47' height='47' rx='4.5' stroke='#C6AD93'/> <path d='M32 23.4414H19.83L25.42 17.8514L24 16.4414L16 24.4414L24 32.4414L25.41 31.0314L19.83 25.4414H32V23.4414Z' fill='#82542D'/></svg> </button>",
            nextArrow:"<button type='button' class='slick-next pull-right'> <svg width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'> <rect x='0.5' y='0.941406' width='47' height='47' rx='4.5' stroke='#C6AD93'/> <path d='M24 16.4414L22.59 17.8514L28.17 23.4414H16V25.4414H28.17L22.59 31.0314L24 32.4414L32 24.4414L24 16.4414Z' fill='#82542D'/> </svg></button>",
            arrow:true,
            infinite: true,
            speed: 300, 
            slidesToShow: 1,
            slidesToScroll: 1
            
          });
        }
      } else {
        if ($('.our-difference-content').hasClass('slick-initialized')) {
          $('.our-difference-content').slick('unslick');
        }
      }
    }

    initSlickDifference();




    $(window).on('resize', function() {
      initSlickDifference();
      initSlick();
      initializeSlick();
      slickFeatured();
      slickAccordion();
    
    });

 

  });


  // JS code for changing background
  jQuery(function($) {
    $(window).scroll(function() {
      var $window = $(window),
          $section = $('.color-fading-section'); 

    
      var scroll = $window.scrollTop() + ($window.height() / 2);

      $section.each(function() {
        var $this = $(this);
        var sectionTop = $this.offset().top;
        var sectionBottom = sectionTop + $this.outerHeight();

      
        if (sectionTop <= scroll && sectionBottom > scroll) {
       
          var newColor = $this.data('bg');
          $section.css('background-color', newColor);
        }
      });
    }).scroll(); 
  });

  // $(document).ready(function() {
  //     $('.featured-image-wrapper').slick({
  //     dots: false,
  //     infinite: true,
  //     autoplay: true,
  //     autoplaySpeed: 3000,
  //     speed: 300,
  //     slidesToShow: 1,
  //     slidesToScroll: 1,
  //     dots:true,
  //     centerMode:true,
  //     cssEase: 'linear',
  //     prevArrow: false,
  //     nextArrow: false,

  //     responsive: [
  //       {
  //           breakpoint: 9999,
  //           settings: "unslick"
  //       },
  //       {
  //         breakpoint: 999,
  //         settings: {
  //           slidesToShow: 1,
  //           slidesToScroll: 1,
            
  //         }
  //       },
  //       {
  //         breakpoint: 500,
  //         settings: {
  //           slidesToShow: 1,
  //           slidesToScroll: 1,
  //           centerPadding: 0
  //         }
  //       }
        
       
  //       // You can unslick at a given breakpoint now by adding:
  //       // settings: "unslick"
  //       // instead of a settings object
  //     ]
  //   });
  // });






/*
  $slickGreen = false;
    function greenSlider(){    
        if($(window).width() < 991){
            if(!$slickGreen){
                $(".product-accordion-slider").slick({
                  lazyLoad: 'onDemand',
                  infinite: true,
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  dots: true,
                  //autoplay: true,
                  autoplaySpeed: 6000,
                });
                $slickGreen = true;
            }
        } else if($(window).width() > 992){
          console.log("test");
            if($slickGreen){
              console.log("test-unslick");
                $('.product-accordion-slider').slick('unslick');
                $slickGreen = false;
            }
        }
    };

    $(document).ready(function(){
        greenSlider();
    });
    $(window).on('resize', function(){
         greenSlider();
    });
    */
    document.addEventListener("DOMContentLoaded", function() {
      console.log("testetsts")
      document.querySelectorAll('.product-card-wrapper .card__heading .full-unstyled-link').forEach(element => {
        element.textContent = element.textContent
          .toLowerCase()
          .replace(/\b\w/g, char => char.toUpperCase());
      });
    });

    $(document).ready(function() { 
      // Get the current URL without query parameters
      var currentUrl = window.location.href.split('?')[0]; 
    
      $('a.button-filter').each(function() {
        // Get the href of the link without query parameters
        var linkUrl = this.href.split('?')[0]; 
    
        // Compare the URLs without query parameters
        if (linkUrl === currentUrl) {
          $(this).addClass('button-trans-active');
        } 
      });
    });


    // document.addEventListener('DOMContentLoaded', function() {
    //   const variantLabels = document.querySelectorAll('.button-variant-cacao');
    
    //   variantLabels.forEach(label => {
    //     label.addEventListener('click', function() {
    //       setTimeout(() => {
    //         const priceItem = document.querySelector('.product .product__info-wrapper .product__info-container .unit-price.hidden .price-item--last.price-change');
            
    //         console.log('Price Item:', priceItem);
    
    //         if (priceItem) {
    //           const priceChangeText = document.querySelector('.product .product__info-wrapper .product__info-container .price-change--text');
    //           console.log('Price Change Text Element:', priceChangeText);
              
    //           if (priceChangeText) {
    //             priceChangeText.textContent = priceItem.textContent;
    //             console.log('Updated price in price-change--text:', priceItem.textContent);
    //           } else {
    //             console.log('Price change text element not found');
    //           }
    //         } else {
    //           console.log('Price item not found');
    //         }
    //       }, 1000);
    //     });
    //   });
    // });

    


  $(document).ready(function () {
    $('.blog-wrapper').slick({
      dots: true,
      nav: true,
      infinite: true,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: 0,
      responsive: [
        {
          breakpoint: 9999,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 749,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });


      var width = window.innerWidth;
      if( width <= 749 ) {
        $('.featured-image-wrapper').slick({
          speed: 5000,
          autoplay: true,
          autoplaySpeed: 0,
          cssEase: 'linear',
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          draggable: false,
          dots:false,
          prevArrow: false,
          nextArrow: false
        });

        
      }
      function toggleParagraphs() {
        $('.text-wrapper').each(function() {
            var $this = $(this);
            var $paragraphs = $this.find('p');

            if ($paragraphs.length > 1) {
                if ($(window).width() <= 749) {
                    // Hide all paragraphs except the first one
                    $paragraphs.slice(1).slideUp(0); // Initially hide all paragraphs except the first
                    $this.find('.see-more').html("<span>open to read full story</span> <svg aria-hidden='true' focusable='false' class='icon down-arrow' viewBox='0 0 24 25' fill='none' xmlns='http://www.w3.org/2000/svg'><path d='M18.707 13.1484L17.293 11.7344L13 16.0274V6.44141H11V16.0274L6.70697 11.7344L5.29297 13.1484L12 19.8554L18.707 13.1484Z' fill='#3A3029'/><path d='M18.707 13.1484L17.293 11.7344L13 16.0274V6.44141H11V16.0274L6.70697 11.7344L5.29297 13.1484L12 19.8554L18.707 13.1484Z' fill='#3A3029'/></svg>").show();

                    // Toggle the paragraphs on click
                    $this.find('.see-more').off('click').on('click', function() {
                        var $toggleBtn = $(this);
                        var $hiddenParagraphs = $this.find('p').slice(1); // All except the first paragraph
                        var $icon = $toggleBtn.find('svg'); // Get the SVG icon
                        var $spanText = $toggleBtn.find('span'); // Get the span for text

                        if ($hiddenParagraphs.is(':visible')) {
                            $hiddenParagraphs.slideUp(300); // Smoothly slide up (hide)
                            $spanText.text("open to read full story"); // Update text
                            $icon.removeClass('rotated'); // Remove rotation class
                        } else {
                            $hiddenParagraphs.slideDown(300); // Smoothly slide down (show)
                            $spanText.text("close full story"); // Update text
                            $icon.addClass('rotated'); // Add rotation class
                        }
                    });
                } else {
                    // Show all paragraphs and hide the "See More" button if screen is larger than 749px
                    $paragraphs.slideDown(0);  // Show all paragraphs without animation
                    $this.find('.see-more').hide();  // Hide the "See More" button
                }
            } else {
                // Hide the button if there is only one <p>
                $this.find('.see-more').hide();
            }
        });
    }

    // Call the function on load
    toggleParagraphs();

    // Call the function on window resize
    $(window).resize(function() {
        toggleParagraphs();
    });
  });
